<template>
  <v-app>
    <router-view></router-view>
  </v-app>
</template>

<script>
//import Home from "./views/Home";

export default {
  name: "App",

  data: () => ({
    //
  }),
  created() {
    this.$store.dispatch("autoLogin");
    this.$store.dispatch("listShops");
  },
  methods: {},
  metaInfo: {
    // if no subcomponents specify a metaInfo.title, this title will be used
    title: "Lubumas",
    // all titles will be injected into this template
    titleTemplate: "%s | Plataforma de eCommerce",
    meta: [
      { charset: "utf-8" },
      {
        property: "og:image",
        content: "https://lubumas.com/img/space3_facebook.png"
      },
      { property: "og:type", content: "website" },
      {
        property: "og:url",
        content: "https://lubumas.com/"
      },
      {
        property: "og:title",
        content: "Lubumas - Plataforma de eCommerce"
      },
      {
        property: "og:description",
        content:
          "Crea tu tienda online y comience a vender! Hemos creado una herramienta que esta optimizada y enfocada directamente para generar ventas efectivas para su negocio."
      },

      { property: "og:site_name", content: "lubumas" },
      // Twitter card
      { name: "twitter:card", content: "summary" },
      {
        name: "twitter:site",
        content: "https://lubumas.com/"
      },
      { name: "twitter:title", content: "Lubumas | Plataforma de eCommerce" },
      {
        name: "twitter:description",
        content:
          "Crea tu tienda online y comience a vender! Hemos creado una herramienta que esta optimizada y enfocada directamente para generar ventas efectivas para su negocio"
      },
      // Your twitter handle, if you have one.
      { name: "twitter:creator", content: "@diegoachury" },
      {
        name: "twitter:image:src",
        content: "https://lubumas.com/img/space3_facebook.png"
      },
      // Google / Schema.org markup:
      { itemprop: "name", content: "Lubumas | Plataforma de eCommerce" },
      {
        itemprop: "description",
        content:
          "Crea tu tienda online y comience a vender! Hemos creado una herramienta que esta optimizada y enfocada directamente para generar ventas efectivas para su negocio"
      },
      {
        itemprop: "image",
        content: "https://lubumas.com/img/space3_facebook.png"
      }
    ]
  }
};
</script>

<style lang="scss">
.v-application {
  height: 100% !important;
  display: flex;
  flex-direction: column;
}
.v-application--wrap {
  min-height: 100% !important;
}
</style>
